import {
  Component,
  Input,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import { CustomSelectOption } from 'src/app/core/interfaces/custom-select-option';
import { CommodityCategory } from 'src/app/core/models/commodity-category';
import { CommodityCategoryService } from 'src/app/core/services/general/commodity-category.service';

@Component({
  selector: 'app-commodity-category-input',
  templateUrl: './commodity-category-input.component.html',
  styleUrls: ['./commodity-category-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: CommodityCategoryInputComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: CommodityCategoryInputComponent,
    },
  ],
})
export class CommodityCategoryInputComponent {
  @Input()
  title = "Select Commodity Category...";

  @Input()
  isDisabled = false;

  public value?: string;
  public localValue?: CustomSelectOption;

  public commodityCategoriesList: Array<CustomSelectOption> = [];

  constructor(
    private commodityCategoryService: CommodityCategoryService,
  ) {
    this.commodityCategoryService
      .all()
      .subscribe((res: Array<CommodityCategory>) => {
        this.commodityCategoriesList = res.map((el) => {
          return {
            name: `${el.name}`,
            value: el.uuid,
          }
        });
        this.writeValue(this.value);
      });
  }

  ngOnInit(): void {
  }

  onChange = (val: string | undefined) => {
  };

  onTouched = () => { };

  touched = false;
  disabled = false;

  writeValue(val?: string) {
    this.value = val;
    if (this.value != undefined || this.value != null) {
      this.localValue = this.commodityCategoriesList.filter((el) => el.value == val)[0];
    }
  }

  onValueChange(val?: CustomSelectOption) {
    this.value = val?.value;
    this.onChange(this.value);
    this.writeValue(this.value);
  }


  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
